var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499512 16.9414C0.499512 25.5018 7.4391 32.4414 15.9995 32.4414C24.5599 32.4414 31.4995 25.5018 31.4995 16.9414C31.4995 8.38099 24.5599 1.44141 15.9995 1.44141C7.4391 1.44141 0.499512 8.38099 0.499512 16.9414Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.499512 16.9414C0.499512 25.5018 7.4391 32.4414 15.9995 32.4414C24.5599 32.4414 31.4995 25.5018 31.4995 16.9414C31.4995 8.38099 24.5599 1.44141 15.9995 1.44141C7.4391 1.44141 0.499512 8.38099 0.499512 16.9414Z",
    fill: "url(#paint0_linear_3935_4635)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.499512 16.9414C0.499512 25.5018 7.4391 32.4414 15.9995 32.4414C24.5599 32.4414 31.4995 25.5018 31.4995 16.9414C31.4995 8.38099 24.5599 1.44141 15.9995 1.44141C7.4391 1.44141 0.499512 8.38099 0.499512 16.9414Z",
    stroke: "#A2A8B0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3935_4635)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.9414C10 11.3891 10.4477 10.9414 11 10.9414C11.5523 10.9414 12 11.3891 12 11.9414C12 12.4937 11.5523 12.9414 11 12.9414C10.4477 12.9414 10 12.4937 10 11.9414ZM19.9999 11.9414C19.9999 11.3891 20.4477 10.9414 20.9999 10.9414C21.5522 10.9414 21.9999 11.3891 21.9999 11.9414C21.9999 12.4937 21.5522 12.9414 20.9999 12.9414C20.4477 12.9414 19.9999 12.4937 19.9999 11.9414ZM11 20.9414C10.4477 20.9414 10 21.3891 10 21.9414C10 22.4937 10.4477 22.9414 11 22.9414C11.5523 22.9414 12 22.4937 12 21.9414C12 21.3891 11.5523 20.9414 11 20.9414ZM15.0004 21.9414C15.0004 21.3891 15.4482 20.9414 16.0004 20.9414C16.5527 20.9414 17.0004 21.3891 17.0004 21.9414C17.0004 22.4937 16.5527 22.9414 16.0004 22.9414C15.4482 22.9414 15.0004 22.4937 15.0004 21.9414ZM16.0004 15.9414C15.4482 15.9414 15.0004 16.3891 15.0004 16.9414C15.0004 17.4937 15.4482 17.9414 16.0004 17.9414C16.5527 17.9414 17.0004 17.4937 17.0004 16.9414C17.0004 16.3891 16.5527 15.9414 16.0004 15.9414ZM15.0004 11.9414C15.0004 11.3891 15.4482 10.9414 16.0004 10.9414C16.5527 10.9414 17.0004 11.3891 17.0004 11.9414C17.0004 12.4937 16.5527 12.9414 16.0004 12.9414C15.4482 12.9414 15.0004 12.4937 15.0004 11.9414ZM11 15.9414C10.4477 15.9414 10 16.3891 10 16.9414C10 17.4937 10.4477 17.9414 11 17.9414C11.5523 17.9414 12 17.4937 12 16.9414C12 16.3891 11.5523 15.9414 11 15.9414ZM19.9999 16.9414C19.9999 16.3891 20.4477 15.9414 20.9999 15.9414C21.5522 15.9414 21.9999 16.3891 21.9999 16.9414C21.9999 17.4937 21.5522 17.9414 20.9999 17.9414C20.4477 17.9414 19.9999 17.4937 19.9999 16.9414ZM20.9999 20.9414C20.4477 20.9414 19.9999 21.3891 19.9999 21.9414C19.9999 22.4937 20.4477 22.9414 20.9999 22.9414C21.5522 22.9414 21.9999 22.4937 21.9999 21.9414C21.9999 21.3891 21.5522 20.9414 20.9999 20.9414Z",
    fill: "#DCDFE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3935_4635",
    x: 10,
    y: 10.9414,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3935_4635"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3935_4635",
    x1: 1.10728,
    y1: 1.94141,
    x2: 1.10728,
    y2: 31.7259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFCFD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderThumb);
export default __webpack_public_path__ + "static/media/slider-thumb.1c9c7b3a25e5d798f339e56d6a15d24b.svg";
export { ForwardRef as ReactComponent };